/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_FormatInputs */

const en_btn_format = /** @type {(inputs: Btn_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const ko_btn_format = /** @type {(inputs: Btn_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포맷`)
};

const ja_btn_format = /** @type {(inputs: Btn_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォーマット`)
};

/**
* | output |
* | --- |
* | "Format" |
*
* @param {Btn_FormatInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const btn_format = /** @type {((inputs?: Btn_FormatInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_FormatInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_format(inputs)
	if (locale === "ko") return ko_btn_format(inputs)
	return ja_btn_format(inputs)
});